

































































































































import {
  Component,
  mixins,
  namespace,
  Prop,
  Vue,
} from 'nuxt-property-decorator'
import Vue2TouchEvents from 'vue2-touch-events'
import { mdiHeartOutline, mdiHeart, mdiGiftOutline } from '@mdi/js'
import LazyHydrate from 'vue-lazy-hydration'
import { IProduct, IProductToFavourites } from '~/assets/interfaces/products'
import { IFavouriteItem } from '~/assets/interfaces/favourites'
import MixinGeneral from '~/assets/mixins/general'
import { filterBonus } from '~/assets/filters/bonus'
Vue.use(Vue2TouchEvents)
const favouritesStore = namespace('favourites')

@Component({
  components: {
    ComponentIcon: () => import('~/components/icon/icon.vue'),
    ComponentProductMoreDetailsLink: () =>
      import('~/components/products/product-more-details-link.vue'),
    LazyHydrate,
    ComponentProductBuyButton: () =>
      import('~/components/products/product-buy-button.vue'),
    ComponentImage: () => import('~/components/images/image.vue'),
    ComponentProductDetailPricesLight: () =>
      import('~/components/products/product-detail-prices-light.vue'),
    ComponentFormButton: () => import('~/components/form/button.vue'),
    ComponentRating: () => import('~/components/rating/rating.vue'),
    ComponentFormButtonIcon: () => import('~/components/form/button-icon.vue'),
    ComponentCatalogLabels: () =>
      import('~/components/catalog/labels/labels.vue'),
    ComponentProductAspects: () =>
      import('~/components/products/product-aspects.vue'),
    ComponentProductFeature: () =>
      import('~/components/products/product-feature.vue'),
  },
  filters: {
    filterBonus,
  },
})
export default class ComponentMobileProductItem3 extends mixins(MixinGeneral) {
  private mdiHeartOutline = mdiHeartOutline
  private mdiHeart = mdiHeart
  private mdiGiftOutline = mdiGiftOutline
  @Prop({
    type: Object,
    default: () => {},
  })
  private item!: IProduct

  @Prop({
    type: Boolean,
    default: false,
  })
  private favourite!: boolean

  @favouritesStore.Action('toFavourites') private toFavourites!: (
    product: IProductToFavourites
  ) => Promise<void>

  @favouritesStore.State('items') private favouritesItems!: IFavouriteItem[]

  private imageNumber = 0
  private isHiddenImageLazyLoad = false

  private get imagesAmount() {
    return this.item.images ? this.item.images.length : 0
  }

  private hover(num: number) {
    this.isHiddenImageLazyLoad = true
    let numTemp = num
    if (numTemp > this.imagesAmount) {
      numTemp = this.imagesAmount
    }
    this.imageNumber = numTemp - 1
  }

  private mounted(): void {
    this.$emit('loaded')
  }

  private get isInFavourites() {
    return !!this.favouritesItems.find((item) => {
      return item.id === this.item.id
    })
  }

  private isLoading = false

  private isLoadingFavourites = false
  private async addToFavourites() {
    const tempProd = {
      id: this.item.id,
    }

    this.isLoadingFavourites = true
    await this.toFavourites(tempProd)
    this.isLoadingFavourites = false
  }

  private get classTitle() {
    return {
      [this.$style.title]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }

  private get classToFavouriteButton() {
    return {
      [this.$style.toFavouriteButton]: true,
      [this.$style.active]: this.isInFavourites,
    }
  }

  private swipeMobile(direction: string) {
    if (direction === 'left') {
      this.hover(this.imageNumber + 2)
    }
    if (direction === 'right') {
      this.hover(this.imageNumber)
    }
  }

  get imageAlt() {
    if (this.imageNumber !== 0 || !this.item.imageMeta) {
      return null
    }

    if (this.item.imageMeta.alt) {
      return this.item.imageMeta.alt
    }
    return null
  }

  get imageTitle() {
    if (this.imageNumber !== 0 || !this.item.imageMeta) {
      return null
    }

    if (this.item.imageMeta.title) {
      return this.item.imageMeta.title
    }
    return null
  }
}
